import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import type { Tag } from "types";

const processOptions = (options: Tag[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function TagSelect(props: any) {
  return (
    <RemoteSelect
      url="tags"
      processOptions={processOptions}
      sorts={["name:ASC"]}
      {...props}
    />
  );
}

export default TagSelect;
